import { SAFE_FRAMEWORK_ADDRESS } from "@safecoin/safe/utils";
//#region src/types/kiosk.ts
/** The Kiosk module. */
const KIOSK_MODULE = `${SAFE_FRAMEWORK_ADDRESS}::kiosk`;
/** The Kiosk type. */
const KIOSK_TYPE = `${KIOSK_MODULE}::Kiosk`;
/** The Kiosk Owner Cap Type */
const KIOSK_OWNER_CAP = `${KIOSK_MODULE}::KioskOwnerCap`;
/** The Kiosk Item Type */
const KIOSK_ITEM = `${KIOSK_MODULE}::Item`;
/** The Kiosk Listing Type */
const KIOSK_LISTING = `${KIOSK_MODULE}::Listing`;
/** The Kiosk Lock Type */
const KIOSK_LOCK = `${KIOSK_MODULE}::Lock`;
/** The Kiosk PurchaseCap type */
const KIOSK_PURCHASE_CAP = `${KIOSK_MODULE}::PurchaseCap`;
//#endregion
export { KIOSK_ITEM, KIOSK_LISTING, KIOSK_LOCK, KIOSK_MODULE, KIOSK_OWNER_CAP, KIOSK_PURCHASE_CAP, KIOSK_TYPE };

//# sourceMappingURL=kiosk.mjs.map